module.exports = "/fast-coin/img/coin/anim/out_2/out_2_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_2/out_2_006.png
// module id = 2312
// module chunks = 5